import { render, staticRenderFns } from "./FornecedorList.vue?vue&type=template&id=639e7415&"
import script from "./FornecedorList.vue?vue&type=script&lang=js&"
export * from "./FornecedorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports